module.exports = "/build/web/svg/tickets-dark.e3ca064204d49cb03e99beab38b759b6.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/tickets-dark.svg
// module id = 232
// module chunks = 24